// Approved ZasyaOnline logo extracted from the supplied brand file
// (Logo-new copy 2.ai). Assets live in /public/assets/.
export const LogoMark = ({ size = 34 }) => (
  <img
    src="/assets/logo-mark.png"
    alt=""
    aria-hidden="true"
    width={size}
    height={size}
    className="object-contain"
    style={{ width: size, height: size }}
  />
);

// `light` renders the lockup on a white chip for dark surfaces (footer).
export const Logo = ({ compact = false, light = false }) => {
  const img = (
    <img
      src="/assets/logo-lockup.png"
      alt="ZasyaOnline"
      className={`w-auto object-contain ${compact ? "h-7" : "h-9"}`}
      data-testid="brand-logo"
    />
  );
  if (light) {
    return <span className="inline-block rounded-xl bg-white px-3.5 py-2.5">{img}</span>;
  }
  return img;
};
